var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPvechicleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7806 31.5262L64.048 31.323C65.8771 31.323 67.5027 32.9489 67.5027 34.7777V40.2648C67.5027 42.0939 65.8768 43.7195 64.048 43.7195H60.3901C60.7965 40.2648 58.1546 37.0133 54.4967 37.0133C51.042 37.0133 48.197 40.2648 48.8065 43.7195H20.3558C20.9654 40.2648 18.1203 37.0133 14.4625 37.0133C11.0077 37.0133 8.16268 40.2648 8.77223 43.7195H7.95945C4.0984 43.7195 2.87886 37.4197 7.34986 35.3874C11.2109 33.3551 18.73 32.5423 21.5757 32.3391C25.2336 28.0716 32.549 25.2266 41.0843 25.2266C48.8065 25.2266 55.716 27.6653 59.7802 31.5263L59.7806 31.5262ZM39.0525 29.4939H39.8653V26.6489C33.5655 26.852 27.4691 28.8844 24.4209 32.5422C29.0948 32.5422 33.5655 32.5422 38.2399 32.339V30.5099C38.2399 29.9003 38.6463 29.4939 39.0527 29.4939L39.0525 29.4939ZM54.4968 38.0292C57.1387 38.0292 59.3742 40.2647 59.3742 42.9066C59.3742 45.5485 57.1387 47.5805 54.4968 47.5805C51.855 47.5805 49.6195 45.5482 49.6195 42.9066C49.6195 40.2647 51.855 38.0292 54.4968 38.0292V38.0292ZM14.4626 38.0292C17.3077 38.0292 19.34 40.2647 19.34 42.9066C19.34 45.5485 17.3077 47.5805 14.4626 47.5805C11.8208 47.5805 9.78874 45.5482 9.78874 42.9066C9.78874 40.2647 11.8211 38.0292 14.4626 38.0292V38.0292ZM41.0837 26.6491V32.3394C46.3675 32.1362 51.6511 31.933 56.7315 31.7298C53.48 28.4783 47.3835 26.6492 41.0837 26.6492V26.6491Z",
    fill: "url(#paint0_linear_8677_44539)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8677_44539",
    x1: 35.9979,
    y1: 20.7558,
    x2: 35.9979,
    y2: 47.5805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvechicleIcon);
export default __webpack_public_path__ + "static/media/pvechicle_icon.5ad51336d40097c76751085fe4a40fd8.svg";
export { ForwardRef as ReactComponent };